// This icon file is generated automatically.
var PAudioOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M12.16 6.1a.13.13 0 00-.13-.13h-.94a.13.13 0 00-.12.12 3.97 3.97 0 11-7.94 0 .13.13 0 00-.12-.12h-.94a.13.13 0 00-.13.12 5.16 5.16 0 004.54 5.12v1.6H4.1c-.2 0-.38.23-.38.5v.56c0 .07.04.13.1.13h6.36c.06 0 .1-.06.1-.13v-.56c0-.27-.17-.5-.38-.5H7.56v-1.59a5.16 5.16 0 004.6-5.13zM7 8.74a2.64 2.64 0 002.66-2.63v-3.5A2.64 2.64 0 007 0a2.64 2.64 0 00-2.66 2.63v3.5A2.64 2.64 0 007 8.75zM5.53 2.62c0-.79.66-1.43 1.47-1.43.81 0 1.47.64 1.47 1.44v3.5c0 .79-.66 1.43-1.47 1.43-.81 0-1.47-.64-1.47-1.43v-3.5z", "fill-rule": "nonzero" } }] }, "name": "p-audio", "theme": "outlined" };
export default PAudioOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PAudioOutlined.js
// module id = 3227
// module chunks = 0